import { useTheme } from '@mui/material';
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { Button, DialogContent, MenuItem, Pagination, Select, Stack } from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { useDispatch, useSelector } from "react-redux";
import { Typography, Dialog, DialogTitle, DialogActions, Box, Paper, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { makeStyles } from "@mui/styles";

import VehicleSave from "./vehicleSave1";
import VehicleManagement from "./Vehicleinfo/VehicleManagement";
import { getAllVehicleInfo, deleteVehicleInfoById, createVehicleInfo } from "../../redux/actions/vehicleInfoActions";
import VehicleAttribute from "./VehicleAttribute";
import VehicleAdditionalAttribute from "./VehicleAdditionalAttribute";
import { getcompanyselectionAction } from "../../redux/actions/companySelectionAction";
import Loader from "../loader/loader";

const initialRows = [
  {
    id: 1,
    car_type: "Rate",
    vin: 5633,
    model_year: "2020",
    model: "shift",
    make: 2019,
    zip_code: 34523,
    country: "USA",
    state: "London",
  },
];

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: 'none',
    },
    '& .MuiDataGrid-window': {
      borderTop: 'none',
    },
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: '"Poppins", sans-serif',
    overflowX: "auto",
    display: "block",
    '@media (min-width: 600px)': {
      display: "table",
    },
  },
  thead: {
    backgroundColor: "#f5f5f5",
    textAlign: "left",
    fontWeight: 600,
    fontSize: "16px",
    '@media (max-width: 600px)': {
      fontSize: "14px",
    },
  },
  th: {
    padding: "12px 16px",
    textAlign: "left",
    fontWeight: '500',
    borderBottom: "2px solid #ddd",
    '@media (max-width: 600px)': {
      padding: "8px 10px",
    },
  },
  tbody: {
    fontSize: "14px",
    color: "#333",
    '@media (max-width: 600px)': {
      fontSize: "12px",
    },
  },
  td: {
    padding: "12px 16px",
    borderBottom: "1px solid #ddd",
    fontWeight: '500',
    '@media (max-width: 600px)': {
      padding: "8px 10px",
    },
  },
  actionCell: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    '@media (max-width: 600px)': {
      gap: "6px",
    },
  },
  paperContainer: {
    width: "100%",
    padding: "28px 20px 22px",
    '@media (min-width: 600px)': {
      padding: "28px 46px 22px 47px",
    },
  },
  paginationContainer: {
    width: "100%",
    overflow: "hidden",
    padding: "16px 0",
    '@media (max-width: 600px)': {
      "& .MuiPagination-ul": {
        flexWrap: "wrap",
        justifyContent: "center",
      },
    },
  },
});

const VehicleInformationList = forwardRef(function VehicleInformationList(props, ref) {
  const { handleNext, handleBack, id } = props;
  const activeStepRef = useRef(null);
  const dispatch = useDispatch();
  const getGpId = useSelector((state) => state.generalPartyInfo.gpId);
  const quoteId = getGpId;

  const classes = useStyles();
  const [showHideVehicleForm, setShowHideVehicleForm] = useState(false);
  const [step, setStep] = useState(1);
  const [vehicleSaveFormData, setVehicleSaveFormData] = useState({});
  const [vehicleAttributeFormData, setVehicleAttributeFormData] = useState({});
  const [backData, setBackData] = useState({});
  const handleSubmitVehicleInfo = async(data) => {
    // setVehicleData(data);
    setVehicleSaveFormData(data);
    handleForward();
  };
   const handleSubmitVehicleNextInfo = async(data) => {
    setVehicleData(data);
  };
  const handleSubmitVehicleAttr = (data) => {
    setVehicleAttributeFormData(data);
    handleForward();
  };

  const handleForward = () => {
    setStep(step + 1);
  };

  const handleBackward = (editedRow) => {
     setBackData(editedRow || {});
    setStep(step - 1);
  };
const handleNextSavingData = (editedRow) => {
     setBackData(editedRow || {});
  };
  const allVehicleInfo = useSelector((state) => state.vehicleInfo.allVehicleInfo);
  const [vehicleData, setVehicleData] = useState({});
  const [rows, setRows] = useState(initialRows);
  const [showLoader, setShowLoader] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [vehicleToDelete, setVehicleToDelete] = useState(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const paginatedRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  useEffect(() => {
    if (quoteId) {
      dispatch(getAllVehicleInfo(quoteId));
    } else if (id) {
      dispatch(getAllVehicleInfo(id));
    }
  }, [dispatch, id, quoteId]);

  useEffect(() => {
    dispatch(getcompanyselectionAction());
  }, [dispatch]);

  useEffect(() => {
    allVehicleInfo.filter((row) => (row.id = row.id)); // (kept as-is from your code)
    setRows(allVehicleInfo || []);
  }, [allVehicleInfo]);

  const handleEditClick = (rowId) => () => {
    setShowHideVehicleForm(true);
    const editedRow = rows.find((row) => row.id === rowId);
    setVehicleData(editedRow || {});
    setStep(1);
  };

  const handleDeleteClick = (rowId) => async () => {
    setVehicleToDelete(rowId);
    setOpenConfirmationDialog(true);
  };

  const confirmDelete = async () => {
    setShowLoader(true);
    const response = await dispatch(deleteVehicleInfoById(vehicleToDelete));
    if (response) {
      setRows((r) => r.filter((row) => row.id !== vehicleToDelete));
      setShowLoader(false);
      setOpenConfirmationDialog(false);
    } else {
      setShowLoader(false);
    }
  };

  const cancelDelete = () => setOpenConfirmationDialog(false);

  function handleClick() {
    setShowHideVehicleForm(true);
    setVehicleData({});
    setStep(1);
  }

  useImperativeHandle(ref, () => ({
    shouldConfirm: () => activeStepRef.current?.shouldConfirm?.() || false,
    saveWithoutNav: () => activeStepRef.current?.saveWithoutNav?.() || Promise.resolve({ ok: true }),
    resetForm: () => activeStepRef.current?.resetForm?.(),
  }));


  const propsForVehicleForm = {
    setShowHideVehicleForm,
    handleForward,
    handleBackward,
    handleNext: handleForward,
    handleBack: handleBackward,
    handleSubmitVehicleInfo,
    handleNextSavingData,
    vehicleData,
    vehicleAttributeFormData,
    backData,
    rows,
    searchQuoteId: id ?? quoteId,
  };

 const finishVehicleFlow = () => {

   setShowHideVehicleForm(false);
   setStep(1);
   setVehicleData({});
   setVehicleSaveFormData({});
   setVehicleAttributeFormData({});
   if (typeof handleNext === 'function') handleNext();
};

  return (
    <>
      {showHideVehicleForm ? (
        <>
          <Box sx={{ marginLeft: "0px" }} id="vehicleForm" name="vehicleForm">
            {step === 1 && (
              <VehicleSave {...propsForVehicleForm} ref={activeStepRef}
              handleNext={handleForward}
                id="vehiclesave"
                name="vehicleSave"
              />
            )}
            {step === 2 && (
              <VehicleAttribute
                ref={activeStepRef}
                setShowHideVehicleForm={setShowHideVehicleForm}
                handleForward={handleForward}
                handleBackward={handleBackward}
                handleSubmitVehicleAttr={handleSubmitVehicleAttr}
                handleSubmitVehicleNextInfo={handleSubmitVehicleNextInfo}
                vehicleData={vehicleData}
                backData={backData}
                vehicleInfoData={vehicleSaveFormData}
                id="vehicleattribute"
                name="vehicleAttribute"
              />
            )}
            {step === 3 && (
              <VehicleAdditionalAttribute
              handleNext={() => {
                 setShowHideVehicleForm(false);
               }}
                handleBackward={handleBackward}
                vehicleInfoData={vehicleSaveFormData}
                vehicleAttrData={vehicleAttributeFormData}
                vehicleData={vehicleData}
                setShowHideVehicleForm={setShowHideVehicleForm}
                ref={activeStepRef}
                searchQuoteId={id ?? quoteId}
                onComplete={finishVehicleFlow}
                id="vehicleadditionalattribute"
                name="vehicleAdditionalAttribute"
              />
            )}
          </Box>
        </>
      ) : (
        <>
          <Box
            sx={{
              width: "100%",
              position: "relative",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              padding: "0px 0px 34px",
              boxSizing: "border-box",
              lineHeight: "normal",
              letterSpacing: "normal",
            }}
            id="vehiclemanagementcontainer"
            name="vehicleManagementContainer"
          >
            <VehicleManagement handleBack={handleBack} handleClick={handleClick} id="vehicleManagement" name="vehicleManagement" />
            <Box
              sx={{
                alignSelf: "stretch",
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "center",
                padding: "0px 20px",
                boxSizing: "border-box",
                maxWidth: "100%",
              }}
              id="vehiclemanagementdetails"
              name="vehicleManagementDetails"
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "853px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "flex-start",
                  gap: "24px",
                }}
                id="vehicledetailscontainer"
                name="vehicleDetailsContainer"
              >
                <Paper
                  className={classes.paperContainer}
                  sx={{
                    borderRadius: '4px',
                    backgroundColor: '#fff',
                    border: '1px solid #e3e3e3',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: '24px',
                    maxWidth: '100%',
                    textAlign: 'left',
                    fontSize: '22px',
                    color: '#242929',
                    fontFamily: '"Poppins", sans-serif',
                  }}
                  id="vehicledetails"
                  name="vehicleDetails"
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'flex-start',
                      justifyContent: 'flex-start',
                      padding: '0px 0px 6px',
                    }}
                    id="vehicletitle"
                    name="vehicleTitle"
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        margin: '0',
                        position: 'relative',
                        fontSize: 'inherit',
                        lineHeight: '20px',
                        fontWeight: '600',
                        fontFamily: 'inherit',
                        display: 'inline-block',
                        minWidth: '115px',
                        zIndex: '1',
                      }}
                      id="vehicletypography"
                      name="vehicleTypography"
                    >
                      Vehicles
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      alignSelf: 'stretch',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      justifyContent: 'flex-start',
                      padding: '0px 0px 8px',
                      gap: '20px',
                      fontSize: '16px',
                      fontFamily: '"Poppins", sans-serif',
                      color: '#888',
                    }}
                    id="vehiclebody"
                    name="vehicleBody"
                  >
                    <div style={{ width: '100%', overflowX: 'auto' }}>
                      <table className={classes.table} id="vehicletable" name="vehicleTable">
                        <thead className={classes.thead}>
                          <tr>
                            <th className={classes.th}>#</th>
                            <th className={classes.th}>Model Year</th>
                            <th className={classes.th}>Make</th>
                            <th className={classes.th}>Model</th>
                            <th className={classes.th}>VIN</th>
                            <th className={classes.th}>Actions</th>
                          </tr>
                        </thead>
                        <tbody className={classes.tbody}>
                          {showLoader ? (
                            <tr>
                              <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                                <Loader />
                              </td>
                            </tr>
                          ) : rows.length === 0 ? (
                            <tr>
                              <td
                                className={classes.td}
                                colSpan="7"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  color: "#888",
                                }}
                              >
                                No Vehicle found
                              </td>
                            </tr>
                          ) : (
                            paginatedRows.map((row, idx) => (
                              <tr key={row.id} id={`vehicleRow_${row.id}`} name={`vehicleRow_${row.id}`}>

                                <td className={classes.td}>{row.vehicleNumber}</td>
                                <td className={classes.td}>{row.modelYear}</td>
                                <td className={classes.td}>{row.manufacturer}</td>
                                <td className={classes.td}>{row.model}</td>
                                <td className={classes.td}>{row.vin}</td>
                                <td className={classes.td}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: "11.5px",
                                      alignItems: "center",
                                    }}
                                  >
                                    <IconButton onClick={handleEditClick(row.id)} id={`editVehicle_${row.id}`} name={`editVehicle_${row.id}`}>
                                      <EditIcon />
                                    </IconButton>
                                    <IconButton
                                      onClick={handleDeleteClick(row.id)}
                                      id={`deleteVehicle_${row.id}`}
                                      name={`deleteVehicle_${row.id}`}
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </Box>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Box>
                  {rows.length > 0 && (
                    <Box className={classes.paginationContainer}>
                      <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        flexWrap="wrap"
                        spacing={2}
                        sx={{
                          '@media (max-width: 600px)': {
                            flexDirection: 'column',
                            alignItems: 'center',
                          },
                        }}
                      >
                        <Box display="flex" alignItems="center">
                          <Typography variant="body2" sx={{ fontSize: '12px', marginRight: '8px' }}>
                            Rows per page:
                          </Typography>
                          <Select
                            value={rowsPerPage}
                            onChange={(e) => {
                              setRowsPerPage(parseInt(e.target.value, 10));
                              setPage(0);
                            }}
                            size="small"
                            sx={{ fontSize: '12px', minWidth: '80px' }}
                          >
                            {[5, 10, 15, 25, 50, 100].map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                        <Pagination
                          count={Math.ceil(rows.length / rowsPerPage)}
                          page={page + 1}
                          onChange={(e, value) => setPage(value - 1)}
                          showFirstButton
                          showLastButton
                          siblingCount={1}
                          boundaryCount={1}
                          size="small"
                        />
                      </Stack>
                    </Box>
                  )}
                  {openConfirmationDialog && (
                    <Dialog
                      open={openConfirmationDialog}
                      onClose={cancelDelete}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle
                        id="alert-dialog-title"
                      >
                        Confirm Delete
                      </DialogTitle>
                      <DialogContent sx={{ marginTop: '15px' }}>
                        Are you sure you want to delete this vehicle? This action cannot be undone.
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={cancelDelete}
                          variant="outlined"
                          size='large'
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={() => {
                            confirmDelete();
                            setOpenConfirmationDialog(false);
                          }}
                          size='large'
                          variant="outlined"
                        >
                          Delete
                        </Button>
                      </DialogActions>
                    </Dialog>
                  )}
                </Paper>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "222px",
                    height: "42px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    gap: "14px",
                  }}
                  id="vehicleactionbuttons"
                  name="vehicleActionButtons"
                >
                  <Button
                    startIcon={<ArrowBackIosIcon />}
                    disableElevation={true}
                    variant="outlined"
                    onClick={handleBack}
                    id="vehiclebackbutton"
                    name="vehicleBackButton"
                  >
                    Back
                  </Button>
                  <Button
                    style={{
                      alignSelf: "stretch",
                      flex: "1",
                      cursor: "pointer",
                      zIndex: "1",
                    }}
                    endIcon={<ArrowForwardIosIcon />}
                    disableElevation={true}
                    variant="contained"
                    onClick={handleNext}
                    id="vehiclenextbutton"
                    name="vehicleNextButton"
                  >
                    Next
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </>
      )}
    </>
  );
});

export default VehicleInformationList;
